import { IMissionPlanWaypoint } from "../missionPlan/IMissionPlanWaypoint"


export interface IArea {
    id:number|null           //Identifiant unique de la zone
    area_label:string    //Un label non obligatoire default
    area_pts:Array<IMissionPlanWaypoint>      //Tableau des waypoints
}

export function getDefaultArea({id=null as number|null,area_label=null,area_pts=[]}={}):IArea {
return {
        id,
        area_label:area_label ?? `Exclude area ${id}`,
        area_pts
    }
}